import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import {
  formatYuan,
  getOrder,
  getPublicConfig,
  type Order,
  type PublicConfig,
} from '../lib/api';

export default function PayGuide() {
  const { code = '' } = useParams();
  const [order, setOrder] = useState<Order | null>(null);
  const [cfg, setCfg] = useState<PublicConfig | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    Promise.all([getOrder(code), getPublicConfig()])
      .then(([o, c]) => {
        setOrder(o);
        setCfg(c);
      })
      .catch(() => setError('订单加载失败'));
  }, [code]);

  const xianyuUrl =
    order && cfg
      ? order.tier === 'deep'
        ? cfg.xianyu_url_deep
        : cfg.xianyu_url_standard
      : '';

  return (
    <section className="stack">
      <div className="work-card">
        <h2 className="type-display-md text-ink">闲鱼支付指引</h2>
        {error ? <div className="error">{error}</div> : null}
        {order ? (
          <>
            <p className="type-body-md text-ink">
              站内订单号：<span className="mono">{order.public_code}</span>
            </p>
            <p className="type-body-md text-ink">
              应付金额：<strong>{formatYuan(order.amount_cents)}</strong>
              <span className="type-body-md text-ink-secondary">
                （{order.tier === 'deep' ? '深度档' : '标准档'}）
              </span>
            </p>
          </>
        ) : (
          <p className="type-body-md text-ink-secondary">加载中…</p>
        )}
      </div>

      <div className="work-card">
        <h2 className="type-display-md text-ink">请按以下步骤操作</h2>
        <ol className="steps">
          <li>打开对应档位的闲鱼商品链接，拍下商品。</li>
          <li>
            在闲鱼订单备注中填写站内订单号 <span className="mono">{code}</span>，方便我们核对。
          </li>
          <li>完成付款后，回到本站提交闲鱼订单号。</li>
          <li>管理员确认到账后，即可进入创作室上传照片并生成。</li>
        </ol>
        {xianyuUrl ? (
          <p className="type-body-md text-ink">
            <a href={xianyuUrl} target="_blank" rel="noreferrer">
              打开闲鱼商品页 →
            </a>
          </p>
        ) : (
          <p className="type-body-md text-ink-secondary">闲鱼链接暂未配置，请联系客服获取对应商品。</p>
        )}
      </div>

      <div className="row">
        <Link className="btn-primary" to={`/order/${code}/xianyu`}>
          我已拍下
        </Link>
        <Link className="btn-secondary" to={`/order/${code}`}>
          查看订单
        </Link>
      </div>
    </section>
  );
}
